<template>
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.333172 6.66667L6.99984 -2.91409e-07L13.6665 6.66667L12.4832 7.85L6.99984 2.36667L1.5165 7.85L0.333172 6.66667Z"/>
  </svg>

</template>
